"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TDocFlag = exports.TDBitToggle = exports.TOGGLE_KEY_PATTERN = exports.TOGGLE_KEY_NAME = void 0;
/**
 * 客户端DB识别Key
 */
exports.TOGGLE_KEY_NAME = 'AppBitShiftToggle';
exports.TOGGLE_KEY_PATTERN = new RegExp("".concat(exports.TOGGLE_KEY_NAME, "/(\\d+)"));
/**
 * UA bitToggle标记位
 *
 * @export
 * @enum {number}
 */
var TDBitToggle;
(function (TDBitToggle) {
    /**
     * 支持全离线能力(离线编辑&离线打开)
     */
    TDBitToggle[TDBitToggle["fullOfflineModeAvailable"] = 1] = "fullOfflineModeAvailable";
    /**
     * 支持客户端数据库
     */
    TDBitToggle[TDBitToggle["nativeDatabaseAvailable"] = 2] = "nativeDatabaseAvailable";
    /**
     *  客户端数据库当前可用，即将废弃
     */
    TDBitToggle[TDBitToggle["nativeDatabaseWillDeprecated"] = 4] = "nativeDatabaseWillDeprecated";
})(TDBitToggle = exports.TDBitToggle || (exports.TDBitToggle = {}));
/**
 *
 * UA _tdocFlag 标记位
 * @export
 * @enum {number}
 */
var TDocFlag;
(function (TDocFlag) {
    /**
     * 支持全离线能力 && 支持客户端数据库
     */
    TDocFlag[TDocFlag["nativeDatabaseAndFullOfflineModeAvailable"] = 2] = "nativeDatabaseAndFullOfflineModeAvailable";
})(TDocFlag = exports.TDocFlag || (exports.TDocFlag = {}));
